/* Import Module */
import { reactive } from "vue";
import $ from "jquery";
import { vueCanvasDrawingRef, rentalContractEditForm } from "../variables";
import { isShow } from "../variables";

/* Define Const */
const defaultWidth = 1052;
export const canvasOptions = reactive({
  additionalImages: [],
  backgroundColor: "#FFFFFF",
  backgroundImage: "",
  canvasId: "vueCanvasDrawing",
  classes: "",
  color: "#000000",
  eraser: false,
  fillShape: false,
  height: 116,
  image: "",
  initialImage: [],
  lineCap: "round",
  lineJoin: "round",
  lineWidth: 2,
  lock: false,
  saveAs: "png",
  strokeType: "dash",
  styles: {
    border: "solid 1px #000",
  },
  watermark: null,
  width: defaultWidth,
});

/* Define Script */
export const canvasEmptyCheck = () => {
  return (
    !rentalContractEditForm.signaturePath && vueCanvasDrawingRef.value.isEmpty()
  );
};

export const getWidthSize = async () => {
  const width = await $("#memo").width();
  if (width < defaultWidth) {
    canvasOptions.width = await width;
  } else {
    canvasOptions.width = defaultWidth;
  }
};

export const resizeWidth = async () => {
  await getWidthSize();
  vueCanvasDrawingRef.value.redraw();
};

export const canvasClear = () => {
  vueCanvasDrawingRef.value.reset();
};

export const setPreviewSignatureImage = () => {
  if (rentalContractEditForm.signaturePath) {
    isShow.canvas = false;
  } else {
    canvasClear();
  }
};

export const getCanvasImageBase64 = () => {
    let base64:any = null;

    if (canvasEmptyCheck()) {
        base64 = null;
    } else if (rentalContractEditForm.signaturePath) {
        base64 = rentalContractEditForm.signaturePath;
    } else {
        base64 = vueCanvasDrawingRef.value.$el.toDataURL();
    }
    return base64;
};
